module.exports = __webpack_public_path__ + "img/bongalo_left_icon.5676d31f.png";